export const africanTechInnovation = {
  id: 1,
  title: "The Rise of African Tech Innovation: A New Era of Digital Transformation",
  author: {
    name: "Themba Ndlovu",
    role: "Chief Innovation Officer",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80"
  },
  date: "March 15, 2024",
  readTime: "12 min read",
  category: "Innovation",
  image: "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80",
  excerpt: "Exploring the transformative journey of African tech innovation and its impact on the global digital landscape.",
  content: `
    The African technology landscape is experiencing an unprecedented transformation, marking the beginning of a new era in digital innovation. From fintech revolutionaries in Lagos to AI pioneers in Cape Town, the continent is witnessing a surge in technological advancement that's reshaping both local and global markets. In this comprehensive exploration, we'll delve into the key drivers, current trends, and future prospects of African tech innovation.

    The Foundation of African Tech Innovation

    Historical Context
    The journey of African tech innovation didn't begin overnight. The continent's unique challenges and opportunities have long served as catalysts for innovative solutions. Limited infrastructure, which might have been seen as a hindrance, has actually spurred the development of groundbreaking solutions that leapfrog traditional development stages. Mobile money solutions, for instance, emerged from the need to serve vast unbanked populations, leading to Africa becoming a global leader in mobile financial services.

    // ... rest of the content ...
  `
}; 